import { Box, styled } from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  BUTTON_TEXT_COLOR,
  FONT_FAMILY,
  SKIP_BUTTON_BACKGROUND_COLOR,
  SKIP_BUTTON_TEXT_COLOR,
  TEXT_COLOR,
} from "../../theme";

export const styles = {
  buttons: {
    backgroundColor: APP_COLOR,
    color: BUTTON_TEXT_COLOR,
    padding: "10px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  trialEndWarningModalButtonsContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "20px",
  } as const,
  buttonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  } as const,
  modalContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    padding: "15px",
    paddingTop: "50px",
  } as const,
  commentContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    margin: 0,
    padding: "15px",
    width: "350px",
  } as const,
  commentsButtonContainer: {
    display: "flex",
    justifyContent: "space-between"
  } as const,
};

export const TrialEndWarningModalContainer = styled(Box)(({ theme }) => ({
  textAlign: "center",
  backgroundColor: APP_BACKGROUND_COLOR,
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  border: "2px solid #000",
  [theme.breakpoints.down("md")]: {
    width: "90%",
  },
}));

export const sendInviteModalStyles = {
  button: {
    backgroundColor: APP_COLOR,
    color: BUTTON_TEXT_COLOR,
    height: "50px",
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  AddEmailContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  sendInviteButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  } as const,
  emailContainer: {
    display: "flex",
    alignContent: "center",
    margin: "8px",
    justifyContent: "space-between",
  },
};

export const addTrackFileModalStyles = {
  bpmInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
  } as const,
  collaboratorAddButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  collaboratorContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  horizontalDiv: {
    width: "100%",
    height: 2,
    backgroundColor: TEXT_COLOR,
    marginBottom: 10,
  } as const,
  emailInviteContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  emailInviteAddButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
};

export const addVersionModalStyles = {
  linearProgressContainer: {
    width: "100%",
    paddingY: 4,
    color: APP_COLOR,
  } as const,
  addingVersionSpan: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  },
};

export const batchTrackAddModalStyles = {
  files: {
    height: 155,
    borderStyle: "dashed",
    borderWidth: "2px",
  } as const,
  fileNameContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  } as const,
  fileMainContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
  } as const,
  fileContainer: {
    display: "flex",
    width: "100%"
  } as const,
  musicVideoIcon: {
    width: "35px",
    height: "35px",
    marginRight: 2,
  } as const,
  uploadContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  uploadButton: {
    padding: "12px 20px",
    borderRadius: "8px",
    marginTop: "10px",
    textTransform: "none",
    backgroundColor: APP_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  uploadButtonContainer: {
    display: "flex",
    height: "100px",
    alignItems: "center",
    justifyContent: "center"
  } as const,
  folderNameContainer: {
    padding: "8px",
    border: `1px solid ${BORDER_COLOR}`,
    marginTop: "5px",
    marginBottom: "5px",
    display: 'flex',
    width: "100%",
    alignItems: "center"
  } as const
};

export const collaboratorsModalStyles = {
  modalFooter: {
    display: "flex",
    backgroundColor: APP_BACKGROUND_COLOR,
    justifyContent: "flex-start",
    alignItems: "flex-start",
  } as const,
  userNameLabelContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  addCollaboratorButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  confirmButton: {
    textTransform: "none",
    mt: 3,
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    height: 50,
    marginBottom: 1,
    width: "100%",
    fontFamily: FONT_FAMILY,
    fontSize: 18,
    fontWeight: "bold",
  } as const,
  inviteCollaboratorContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  inviteCollaboratorMainContainer: {
    width: "100%",
    height: 2,
    backgroundColor: "white",
    marginBottom: 10,
  } as const,
  customButtonStyles: {
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
  } as const,
  collaboratorContainer: {
    marginBottom: 40,
    width: "100%"
  } as const,
  profilePic: {
    width: "35px",
    height: "35px",
    marginRight: "10px",
    borderRadius: "50%",
  } as const,
  creatorsContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  usernameLabel: {
    display: "block",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    marginBottom: 8,
    fontWeight: 500,
  } as const,
  addButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  collaboratorsUserName: {
    fontFamily: FONT_FAMILY,
    flexGrow: 1,
    color: TEXT_COLOR,
  } as const,
};

export const modalContainerStyles = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export const publishPermissionModalStyles = {
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "30px",
  } as const,
  button: {
    backgroundColor: APP_COLOR,
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    textTransform: "none",
  } as const,
};

export const userStatusModalStyles = {
  headingContainer: {
    textAlign: "center",
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    paddingY: 1,
  } as const,
  heading: {
    fontWeight: "bold",
    marginTop: "10px",
    fontFamily: FONT_FAMILY,
  } as const,
  modalBodyContainer: {
    textAlign: "center",
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
  } as const,
  loginSignUpButton: {
    paddingY: 1,
    paddingX: 2,
    fontFamily: FONT_FAMILY,
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
  } as const,
};

export const trackAddModalStyles = {
  albumInput: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: BORDER_COLOR,
  } as const,
  genreLabel: {
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
  } as const,
  bpmLoadingContainer: {
    width: "100%",
    paddingY: 4,
    color: APP_COLOR,
  } as const,
  userNameSelectFieldContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
  } as const,
  addUserNameButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  uploadingSpan: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  } as const,
  email: {
    fontFamily: FONT_FAMILY,
    flexGrow: 1,
  } as const,
  inviteEmailButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  inviteEmailContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    marginBottom: 2,
  } as const,
  inviteEmailMainContainer: {
    dth: "100%",
    height: 2,
    backgroundColor: "white",
    marginBottom: 10,
  } as const,
  bpmContainer: {
    display: "flex",
    flexDirection: "row",
  } as const,
  imageIconMainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  imageIconContainer: {
    border: "1px solid gray",
    padding: "10px",
    borderRadius: "13px",
    marginBottom: "10px",
  } as const,
  coverArtLabel: {
    borderWidth: "1px",
    width: "100%",
    height: "300px",
    borderColor: BORDER_COLOR,
  } as const,
  headerIconContainer: {
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    marginBottom: "10px",
    backgroundColor: APP_COLOR,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
};

export const createFolderStyles = {
  container: {
    backgroundColor: APP_BACKGROUND_COLOR,
    padding: "10px",
    width: "400px",
  } as const,
};

export const FileTrackLinkingModalStyles = {
  addButton: {
    backgroundColor: APP_COLOR,
    color: BUTTON_TEXT_COLOR,
    marginTop: "15px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  },
};

export const shareModalStyles = {
  updateSubContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "auto",
  } as const,
  subscriptionInfoModal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "auto",
  } as const,
  listContainer: {
    paddingLeft: 2,
    margin: "8px 0 16px 0",
    listStyleType: "disc",
    listStylePosition: "inside",
  } as const,
  listItem: {
    color: TEXT_COLOR,
    display: "list-item"
  } as const,
  mainContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: APP_BACKGROUND_COLOR,
    boxShadow: 24,
    padding: "20px",
    borderRadius: "15px",
  } as const,
  shareIcons: {
    width: "25px",
    height: "25px",
    filter: "invert(100%)",
  } as const,
  editCollaboratorContainer: {
    fontFamily: "Argumentum",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "28px",
    mb: 5,
  } as const,
  shareIconContainer: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: APP_COLOR,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "10px 0",
  } as const,
  topBarIconContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  } as const,
  closeIconContainer: {
    display: "flex",
    alignItems: "center",
  } as const,
  title: {
    color: TEXT_COLOR,
    fontWeight: "bold",
    fontSize: "20px",
    marginTop: "5px",
  } as const,
  delteModalText: {
    color: TEXT_COLOR,
    fontSize: "18px",
    marginY: "20px",
    textAlign: 'center',
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    "&:disabled": {
      backgroundColor: "gray",
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
    width: "100%",
  } as const,
  CancelButton: {
    borderRadius: "var(--radius-md, 8px)",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    textTransform: "none",
    marginLeft: 2,
    width: "48%",
  } as const,
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
  } as const,
  selectMenuProps: {
    "& ul": {
      padding: 0,
    },
  } as const,
  uploadAudioMainContainer: {
    position: "relative",
    overflow: "hidden",
    border: "1px solid gray",
    height: "120px",
    width: "100%",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  uploadAudioInput: {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  } as const,
  musicNoteIconContainer: {
    border: "2px solid #697177",
    borderRadius: "8px",
    width: "45px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "3px",
    color: TEXT_COLOR,
    borderColor: TEXT_COLOR,
  } as const,
  label: {
    display: "block",
    color: TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    marginBottom: 8,
    fontWeight: 500,
  } as const,
  addButton: {
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginLeft: 1,
    height: 52,
    marginBottom: 0.5,
    width: "20%",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
  } as const,
  typography: {
    color: TEXT_COLOR,
    marginTop: "15px",
    marginBottom: "10px",
  } as const,
  select: {
    width: "100%",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  } as const,
  fileDetails: {
    margin: "15px 0px 15px 0px",
    padding: "10px",
    border: "1px solid gray",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  } as const,
  setMaxViews: {
    color: TEXT_COLOR,
    marginTop: "15px",
    marginBottom: "10px",
  } as const,
  inviteCollaboratorDetailsBox: {
    padding: "10px",
    marginBottom: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid gray",
    borderRadius: "10px",
  } as const,
  emailDetailsMainContainer: {
    width: "100%",
    marginTop: "15px",
  } as const,
  autoCompleteAddButton: {
    border: "3px solid gray",
    height: "54px",
    borderTopRightRadius: "12px",
    borderBottomRightRadius: "12px",
  } as const,
  addVersionButton: {
    width: "100%",
    backgroundColor: "#0078A1",
    color: "white",
    textTransform: "none",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  closeButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 2
  } as const,
  updatePlanButton: {
    textTransform: "none",
    backgroundColor: APP_COLOR,
    borderRadius: 2,
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  updatePlanContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 2
  } as const,
  watchTutorial: {
    marginLeft: "4px",
    textDecoration: "none",
    color: "#007BFF",
  } as const,
};

export const CustomTrackAddFileModalContainer = styled(Box)(({ theme }) => ({
  width: "40%",
  position: "absolute" as const,
  top: "65%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: APP_BACKGROUND_COLOR,
  boxShadow: "24",
  padding: "20px",
  borderRadius: "15px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const AddCollaboratorsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: "10px",
  gap: "10px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const TrackAddModalMainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const TrackAddModalColumnContainer = styled(Box)(({ theme }) => ({
  width: "45%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const TrackEditModalColumnContainer = styled(Box)(({ theme }) => ({
  width: "100%",
}));

export const TrackAddModalFormContainer = styled(Box)(({ theme }) => ({
  backgroundColor: APP_BACKGROUND_COLOR,
  color: TEXT_COLOR,
  width: "55%",
  [theme.breakpoints.down("md")]: {
    width: "80%",
  },
}));
export const TrackEditModalFormContainer = styled(Box)(({ theme }) => ({
  backgroundColor: APP_BACKGROUND_COLOR,
  color: TEXT_COLOR,
  position: "absolute",
  top: "75%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  padding: "20px",
  borderRadius: "15px",
}));

export const messageModalStyles = {
  postMessageModal: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: APP_BACKGROUND_COLOR,
    padding: 40,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 8,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
  } as const,
  postMessageModalIcon: {
    position: "absolute",
    top: 15,
    right: 15,
    color: APP_COLOR,
  } as const,
  messageBox: {
    fontSize: 20,
    marginBottom: 10,
    textAlign: "center",
    color: TEXT_COLOR,
  } as const,
  modalBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    width: "100%"
  } as const,
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1500,
  } as const,
};


export const addProjectModalStyles = {
  modal: {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    border: "2px solid #000",
    boxShadow: 24,
    p: "15px",
    marginTop: '20px',
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  button: {
    display: "inline-block",
    padding: "10px 20px",
    cursor: "pointer",
    backgroundColor: APP_COLOR,
    color: "black",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    textTransform: "none",
    height: "40px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  addProjectButton: {
    borderRadius: "var(--radius-md, 8px)",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background:
      "var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #161B26)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: "var(--Component-colors-Components-Buttons-Secondary-color-button-secondary-color-fg, #CECFD2)",
    textTransform: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "7px",
  } as const,
  bottomContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    margin: "15px 0px 15px 0px",
  } as const
}


export const addItemsModalStyles = {
  chip: {
    fontSize: "0.85rem",
    padding: "0.5rem",
    backgroundColor: APP_BACKGROUND_COLOR,
    borderRadius: "8px",
  } as const,
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    marginTop: 1,
  } as const,
  buttonsContainer: {
    marginBottom: "10px",
    display: "flex",
    justifyContent: "center",
  } as const,
  chooseMoreFilesButton: {
    backgroundColor: APP_COLOR,
    color: "white",
    marginTop: '15px',
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  artWorkImg: {
    width: "120px",
    height: "120px",
  } as const,
  typography: {
    color: TEXT_COLOR,
    fontWeight: "bold",
    textAlign: "center",
  } as const,
  cloudUploadIcon: {
    fontSize: 60,
    color: APP_COLOR,
    marginBottom: "10px",
  } as const,
  uploadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    flexDirection: "column",
    borderRadius: "8px",
    backgroundColor: APP_BACKGROUND_COLOR,
    transition: "border 0.3s ease",
  } as const
}

export const splitSheetStyles = {
  filterNoneIcon: {
    padding: "10px",
    borderRadius: "50%",
    backgroundColor: APP_COLOR,
  } as const,
  adminPanel: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "15px",
    gap: "15px",
  } as const,
  trackDetails: {
    height: "150px",
    display: "flex",
    marginTop: "10px",
  } as const,
  trackImage: {
    width: "180px",
    height: "200px",
    borderRadius: "10px",
  } as const,
  button: {
    backgroundColor: APP_COLOR,
    color: BUTTON_TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    marginTop: "35px",
    height: "52px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  saveButton: {
    backgroundColor: APP_COLOR,
    color: BUTTON_TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  skipButton: {
    borderRadius: "var(--radius-md, 8px)",
    marginTop: "35px",
    height: "52px",
    border:
      "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #4C5155)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    textTransform: "none",
  } as const,
  th: {
    display: "flex",
    justifyContent: "space-around",
    background: "var(--Colors-Background-bg-secondary, #161B26)",
    padding: "10px",
    minWidth: "800px",
    borderRadius: "var(--radius-xl, 12px)",
    alignItems: "top"
  } as const,
  td: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    minWidth: "800px",
  } as const,
  modal: {
    overflowY: "scroll",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  tableScrollContainer: {
    overflow: "scroll",
    scrollbarWidth: "none",
    borderRadius: "var(--radius-xl, 12px)",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  tableContainer: {
    border: `1px solid ${BORDER_COLOR}`,
    marginTop: "20px",
    borderRadius: "var(--radius-xl, 12px)",
    minWidth: "800px",
  } as const,
  tab: {
    textTransform: "none",
    borderRadius: "var(--radius-sm, 6px)",
    width: "150px",
    height: "20px",
    fontWeight: "bold",
    minHeight: "30px",
    padding: "6px 6px",
    color: TEXT_COLOR,
    "&.Mui-selected": {
      color: TEXT_COLOR,
    },
    "&:focus": {
      color: TEXT_COLOR,
    },
  } as const,
}

export const addEnterpriseMemberModalStyles = {
  addMemberContainer: {
    display: "flex",
    justifyContent: "space-between"
  } as const,
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: APP_BACKGROUND_COLOR,
    boxShadow: 24,
    padding: 3,
    borderRadius: "var(--radius-xl, 12px)"
  } as const,
  updateRoleContainer: {
    display: "flex",
    justifyContent: "space-between"
  } as const,
  addPersonIconContainer: {
    backgroundColor: APP_COLOR,
    borderRadius: "50%",
    width: "45px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px",
    marginTop: "20px",
  } as const,
  detailsContainer: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "15px",
    gap: "20px",
  } as const,
  heading: {
    color: TEXT_COLOR,
    fontWeight: "bold",
    marginTop: "10px",
  } as const,
  projectCollaboratorContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    maxHeight: "100vh",
    backgroundColor: APP_BACKGROUND_COLOR,
    border: "2px solid #000",
    boxShadow: 24,
    borderRadius: "var(--radius-md, 8px)",
    padding: 3,
    overflow: 'scroll',
    scrollbarWidth: 'none'
  } as const,
}


export const SplitSheetDetailsContainer = styled(Box)(({ theme }) => ({
  marginLeft: "15px",
  width: "60%",
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gridTemplateRows: "repeat(2, 1fr)",
  gap: "10px",
  [theme.breakpoints.down("md")]: {
    display: 'none'
  },
}));

export const SplitSheetModalStyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: APP_BACKGROUND_COLOR,
  border: "2px solid #000",
  padding: '20px',
  maxHeight: "90vh",
  overflowY: "scroll",
  scrollbarWidth: "none",
  borderRadius: "var(--radius-xl, 12px)",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("lg")]: {
    width: "100%"
  },
}));
